import { Grid } from "@material-ui/core"
import { useDevice } from "components/DeviceContext.js";
import { Card1, Card2 } from "components/Card";
import SelectConsulteMunicipio from 'components/SelectConsulteMunicipio'

const PotencialdeArrecadacao = () => {
    const { isMobile, isLaptop } = useDevice();
    return (
        <>
            <Grid container item xs={12} md={12}
                style={{
                    display: 'flex',
                    justifyContent:  'space-around',
                    padding: '2rem',
                    marginBottom: '2em',
                    maxHeight: isMobile ? '200vh': isLaptop ? '200vh' : '100vh'

                }}>
                <Grid item xs={12} md={6} lg={5} >
                    <h1 style={{ color: 'var(--azul-vivido)', fontSize: isMobile ? '1.2em' : '3em' }}>Fia Municipal</h1>
                    <p style={{ fontSize: isMobile ? '1.2em' : '1.6em' }}>Conheça o potencial de captação de recursos do seu Município , por meio de doações dedutíveis do Imposto de Renda (IR), para aumentar as receitas do FIA.</p>
                <SelectConsulteMunicipio />

                </Grid>

                <Grid item xs={12} md={4} style={{
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Card1 />
                    <Card2 />

                </Grid>

            </Grid>
        </>
    )
}


export default PotencialdeArrecadacao;
